// Image zoom on hover. Changed from Dawn's original: the full-size image preloads once the pointer
// rests on it (so a later click opens with no spinner), panning moves an <img> with a composited
// transform instead of repainting background-position, and it only runs where there is a real pointer.
const HOVER_INTENT_MS = 150;
const preloadedImages = new Map();

// load the full-size image once per src
function preloadImage(src) {
  let entry = preloadedImages.get(src);
  if (entry) return entry;

  entry = { loaded: false };
  const loader = new Image();
  loader.onload = () => {
    entry.loaded = true;
  };
  loader.src = src;
  preloadedImages.set(src, entry);
  return entry;
}

function prepareOverlay(container, image, zoomRatio) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.overflow = 'hidden';
  container.style.backgroundColor = 'var(--gradient-background)';

  const zoomedImage = document.createElement('img');
  zoomedImage.setAttribute('src', image.src);
  zoomedImage.setAttribute('alt', '');
  zoomedImage.style.cssText = `position:absolute;top:0;left:0;width:${
    image.width * zoomRatio
  }px;height:auto;max-width:none;transform-origin:0 0;will-change:transform;pointer-events:none`;
  container.appendChild(zoomedImage);
  return zoomedImage;
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function createOverlay(image, zoomRatio) {
  const overlay = document.createElement('div');
  const zoomedImage = prepareOverlay(overlay, image, zoomRatio);
  const preloaded = preloadedImages.get(image.src);

  if (preloaded && preloaded.loaded) {
    image.parentElement.insertBefore(overlay, image); // cached by the hover: no spinner
  } else {
    image.style.opacity = '50%';
    toggleLoadingSpinner(image);

    zoomedImage.onload = () => {
      toggleLoadingSpinner(image);
      image.parentElement.insertBefore(overlay, image);
      image.style.opacity = '100%';
    };
  }

  return { overlay, zoomedImage };
}

function moveWithHover(image, event, zoomRatio, zoomedImage, state) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = xPosition / image.clientWidth;
  const yPercent = yPosition / (image.clientWidth * ratio);

  // same offset background-position used to give us
  state.x = xPercent * (image.clientWidth - image.width * zoomRatio);
  state.y = yPercent * (image.clientWidth * ratio - image.width * zoomRatio * ratio);

  if (state.frame) return;
  state.frame = requestAnimationFrame(() => {
    state.frame = null;
    zoomedImage.style.transform = `translate3d(${state.x}px, ${state.y}px, 0)`;
  });
}

function magnify(image, zoomRatio) {
  const { overlay, zoomedImage } = createOverlay(image, zoomRatio);
  const state = { x: 0, y: 0, frame: null };
  const close = () => {
    if (state.frame) cancelAnimationFrame(state.frame);
    overlay.remove();
  };

  overlay.onclick = close;
  overlay.onmouseleave = close;
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, zoomedImage, state);

  return { zoomedImage, state };
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    let hoverIntent;

    image.addEventListener('mouseenter', () => {
      hoverIntent = setTimeout(() => preloadImage(image.src), HOVER_INTENT_MS);
    });
    image.addEventListener('mouseleave', () => clearTimeout(hoverIntent));

    image.onclick = (event) => {
      const { zoomedImage, state } = magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio, zoomedImage, state);
    };
  });
}

// touch devices keep the theme's own image behaviour
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  enableZoomOnHover(2);
}
